import script from "./PlanPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanPreview.vue?vue&type=script&setup=true&lang=js"

import "./PlanPreview.vue?vue&type=style&index=0&id=328b0cb9&lang=less&scoped=true"
script.__scopeId = "data-v-328b0cb9"

export default script